import { Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { ApplePaySessionErrors } from '../../../../../mappers/errors-mapping.js';

// apple doesnt validate all shipping data for all countries. For example, for Spain it doesn't
const isPostalCodeValid = (country, postalCode)=>{
    if (!postalCode) return false;
    // In this case we can't do the full validation, because if the postal code includes a space, apple will only return the part before the space plus the space at the end. (bug).
    // for example: "W1S 3BE" will be returned here as "W1S "
    // this data IS fully validated again after the payment authorization
    if (postalCode.charAt(postalCode.length - 1) === ' ') return true // checks if the last character is equal to a space
    ;
    return country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
};
const useValidateShippingData = ()=>{
    const { getLabel , country  } = useIntl();
    return (e, session, paymentRequest)=>{
        try {
            const { shippingContact  } = e;
            let valid = true;
            if (shippingContact.countryCode !== country) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'country', getLabel(ApplePaySessionErrors.ApplePayInvalidAddress)), 
                    ]
                });
                valid = false;
            }
            if (!isPostalCodeValid(shippingContact.countryCode, shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode)) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                    ]
                });
                valid = false;
            }
            if (!shippingContact.locality) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'locality', getLabel('checkout.address.city.errorMessage')), 
                    ]
                });
                valid = false;
            }
            return valid;
        } catch (e1) {
            // Swallow InvalidAccessError
            if (!(e1 instanceof Error && e1.name === 'InvalidAccessError')) {
                throw e1;
            }
            return true;
        }
    };
};

export { useValidateShippingData };
//# sourceMappingURL=use-validate-shipping-data.js.map
